// Централизованная конфигурация API URL
// Использует переменную окружения REACT_APP_API_URL если она установлена
// Иначе использует https://gornyak.space для продакшена
// Для локальной разработки установите REACT_APP_API_URL=http://localhost:8000

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gornyak.space';

// Ссылка «Метрики» в сайдбаре: Grafana или сырые метрики backend
// REACT_APP_METRICS_URL — например https://grafana.your-domain.com или https://your-domain.com/metrics
// Если не задана — строится из базового URL бэкенда (без /api) + /metrics
const backendBase = API_BASE_URL.replace(/\/api\/?$/, '').replace(/\/$/, '');
export const METRICS_URL = process.env.REACT_APP_METRICS_URL || `${backendBase}/metrics`;
